import { render, staticRenderFns } from "./client-header.vue?vue&type=template&id=37eecffc&scoped=true&lang=pug"
import script from "./client-header.js?vue&type=script&lang=js&external"
export * from "./client-header.js?vue&type=script&lang=js&external"
import style0 from "./client-header.vue?vue&type=style&index=0&id=37eecffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eecffc",
  null
  
)

export default component.exports